// src/components/process/MobileSummaryCard.jsx

import React from "react";

export default function MobileSummaryCard({ summary }) {
  if (!summary) return null;

  const achievementRate = Number(summary.achievement_rate) || 0;
  const planTotal = Number(summary.plan_total) || 0;
  const actualTotal = Number(summary.actual_total) || 0;

  return (
    <div className="bg-white rounded-xl px-4 py-3 border">
      <div className="flex flex-col gap-2">
        {/* 기간 */}
        <div>
          <span className="text-gray-500 text-xs mr-1">기간</span>
          <span className="text-sm font-semibold text-gray-900">
            {summary.period_start} ~ {summary.period_finish}
          </span>
        </div>

        {/* 실적 / 계획 */}
        <div>
          <span className="text-gray-500 text-xs mr-1">실적/계획</span>
          <span className="text-sm font-semibold text-gray-900">
            {Math.round(actualTotal).toLocaleString()} /{" "}
            {Math.round(planTotal).toLocaleString()}
          </span>
        </div>

        {/* 달성률 */}
        <div className="flex flex-col gap-1">
          <div className="flex justify-between">
            <span className="text-gray-500 text-xs">달성률</span>
            <span className="text-sm font-semibold text-blue-600">
              {achievementRate}%
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded h-2">
            <div
              className="h-2 rounded bg-blue-500"
              style={{ width: `${Math.min(achievementRate, 100)}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

